"use client";

import { Image } from "@template/components";
import GoogleReviews from "./googlereviews.svg";

export default function GoogleWidget() {
  return (
    <a
      href="https://www.google.com/maps/place/Yay.com+-+VoIP-Based+Business+Phone+System/@51.2418472,-0.5825378,17z/data=!3m2!4b1!5s0x4875d0be3c432b6d:0x1d684b311d513ff7!4m6!3m5!1s0x4875d0915c7d84ab:0xcdb88a3a6e150faa!8m2!3d51.2418439!4d-0.5799575!16s%2Fg%2F11c5s7zkw3?entry=ttu&g_ep=EgoyMDI1MDQyMC4wIKXMDSoASAFQAw%3D%3D"
      title="Google Reviews"
      target="_blank"
      rel="noopener noreferrer"
    >
      <Image
        src={GoogleReviews}
        alt="Google Reviews Image"
        style={{ height: 90, width: 200 }}
      />
    </a>
  );
}
